import { Component, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, FormGroupDirective, Validators } from '@angular/forms';
import { DateAdapter, MAT_DATE_FORMATS, MAT_DATE_LOCALE } from '@angular/material';
import { MomentDateAdapter } from '@angular/material-moment-adapter';
import * as moment from 'moment';
import { Moment } from 'moment';
import { MeterModel } from 'src/app/models/index';
import { CommonService, LoadService, SiteService } from 'src/app/services';
import { DataService } from 'src/app/services/data.service';
import { AlertService, Constants } from 'src/app/shared';

@Component({
  selector: 'app-realtime-data',
  templateUrl: './realtime-data.component.html',
  styleUrls: ['./realtime-data.component.scss'],
  providers: [
    { provide: DateAdapter, useClass: MomentDateAdapter, deps: [MAT_DATE_LOCALE] },
    { provide: MAT_DATE_FORMATS, useValue: Constants.DATE_RANGES_PROVIDER_FORMAT },
  ]
})

/**
 *
 *
 * @export
 * @class RealtimeDataComponent
 * @implements {OnInit}
 */
export class RealtimeDataComponent implements OnInit {

  @ViewChild('formDirective') formDirective: FormGroupDirective;
  displayAllSiteID: boolean;
  formRealtimeData: FormGroup
  siteId: string;
  sites: any;
  selectedSite: string;
  meterData: any;
  meterId: any;
  max = new Date();
  dateBound: number = 10;
  startDateCtr = new FormControl(moment());
  endDateCtr = new FormControl(moment());
  isValidStartDate = true;
  startDateErrorMessage: String;
  isValidEndDate = true;
  endDateErrorMessage: String;
  fileName: string;


  /**
   * Creates an instance of RealtimeDataComponent.
   * @param {FormBuilder} fb
   * @param {SiteService} siteService
   * @param {LoadService} loadService
   * @param {CommonService} commonService
   * @param {DataService} dataService
   * @param {AlertService} alertService
   * @memberof RealtimeDataComponent
   */
  constructor(private fb: FormBuilder, private siteService: SiteService, private loadService: LoadService,
    private commonService: CommonService, private dataService: DataService, private alertService: AlertService) {
    this.formRealtimeData = this.fb.group({
      siteCtr: ['', [Validators.required]],
      loadCtr: ['', [Validators.required]],
      startDateCtr: [''],
      endDateCtr: ['']
    });
  }

  /**
   * ngOnInit function
   *
   * @memberof RealtimeDataComponent
   */
  ngOnInit() {
    this.getSiteDetails();
    this.formRealtimeData.reset();
  }

  /**
   * Function to get list of Sites
   *
   * @memberof RealtimeDataComponent
   */
  getSiteDetails() {
    //Check for access to multiple sites
    if (localStorage.getItem('isMultipleSites') === 'false') {
      this.displayAllSiteID = false;
      this.selectedSite = localStorage.getItem('siteId');
      this.formRealtimeData.get('siteCtr').setValidators(null);
      this.formRealtimeData.get('siteCtr').updateValueAndValidity();
      this.getMeterDetails();
    } else {
      this.displayAllSiteID = true;
    }
    this.siteService.getSiteDetails().subscribe(data => {
      this.sites = data;
    });
  }

  /**
   * Function to get list of Meters
   *
   * @memberof RealtimeDataComponent
   */
   getMeterDetails() {
    this.siteId = this.selectedSite;
    this.siteService.getAllMetersforSiteId(this.siteId).subscribe(data => {
      this.meterData = [];
      for (let i = 0; i < data.length; i++) {
        const  model: MeterModel = data[i];
        model.order = i + 1;
        this.meterData.push(model);
      }
    });
  }

  /**
   * Function call to check validations for Start Date
   *
   * @memberof RealtimeDataComponent
   */
  validateStartDate() {
    var modelData = this.commonService.validateStartDate(this.dateBound, this.startDateCtr, this.endDateCtr, this.isValidStartDate, this.isValidEndDate, this.startDateErrorMessage, this.endDateErrorMessage);
    this.startDateCtr = modelData.startDateCtr;
    this.endDateCtr = modelData.endDateCtr;
    this.isValidEndDate = modelData.isValidEndDate;
    this.isValidStartDate = modelData.isValidStartDate;
    this.startDateErrorMessage = modelData.startDateErrorMessage;
    this.endDateErrorMessage = modelData.endDateErrorMessage;
  }

  /**
   * Function call to check validations for End Date
   *
   * @memberof RealtimeDataComponent
   */
  validateEndDate() {
    var modelData = this.commonService.validateEndDate(this.dateBound, this.startDateCtr, this.endDateCtr, this.isValidStartDate, this.isValidEndDate, this.startDateErrorMessage, this.endDateErrorMessage);
    this.startDateCtr = modelData.startDateCtr;
    this.endDateCtr = modelData.endDateCtr;
    this.isValidEndDate = modelData.isValidEndDate;
    this.isValidStartDate = modelData.isValidStartDate;
    this.startDateErrorMessage = modelData.startDateErrorMessage;
    this.endDateErrorMessage = modelData.endDateErrorMessage;
  }

  /**
  * Function call on change of year in start datepicker
  *
  * @param {Moment} normalizedYear
  * @memberof RealtimeDataComponent
  */
  chosenStartDate_YearHandler(normalizedYear: Moment) {
    const ctrlValue = this.startDateCtr.value;
    ctrlValue.year(normalizedYear.year());
    this.startDateCtr.setValue(ctrlValue);
  }

  /**
  * Function call on change of month in start datepicker
  *
  * @param {Moment} normalizedMonth
  * @memberof RealtimeDataComponent
  */
  chosenStartDate_MonthHandler(normalizedMonth: Moment) {
    const ctrlValue = this.startDateCtr.value;
    ctrlValue.month(normalizedMonth.month());
    this.startDateCtr.setValue(ctrlValue);
  }

  /**
  * Function call on change of year in End datepicker
  *
  * @param {Moment} normalizedYear
  * @memberof RealtimeDataComponent
  */
  chosenEndDate_YearHandler(normalizedYear: Moment) {
    const ctrlValue = this.endDateCtr.value;
    ctrlValue.year(normalizedYear.year());
    this.endDateCtr.setValue(ctrlValue);
  }

  /**
  * Function call on change of month in End datepicker
  *
  * @param {Moment} normalizedMonth
  * @memberof RealtimeDataComponent
  */
  chosenEndDate_MonthHandler(normalizedMonth: Moment) {
    const ctrlValue = this.endDateCtr.value;
    ctrlValue.month(normalizedMonth.month());
    this.endDateCtr.setValue(ctrlValue);
  }

  /**
   * Function to show field errors for form
   *
   * @param {string} fieldName
   * @param {string} errorCode
   * @memberof RealtimeDataComponent
   */
  public isFieldHasError = (fieldName: string, errorCode: string): boolean => {
    return this.formRealtimeData.get(fieldName).hasError(errorCode);
  }


  /**
  * Function call happen when user clicks Submit button with buttonId submitRealtimeDataForm
  *
  * @memberof RealtimeDataComponent
  */
  submitRealtimeDataForm() {
    let url = '';
    //Change value of Date into String
    var fromDate = this.commonService.transform(this.startDateCtr);
    var toDate = this.commonService.transform(this.endDateCtr);

    this.fileName = "RealtimeData_" + this.siteId + "(" + this.meterId + ")";

    //API call to get Realtime Data export Report url
    url = this.commonService.getRealTimeDataExportUrl(this.siteId, this.meterId, fromDate, toDate);

    // API to generate excel
    this.dataService.getPDF(url, true).subscribe((response) => {
      if (response.byteLength > 0) {
        const file = new Blob([response], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
        const fileURL = URL.createObjectURL(file);
        // window.open(fileURL, '_blank');
        // Provide filename to the exported file
          const fileName = document.createElement('a')
          fileName.href = fileURL
          fileName.download = this.fileName;
          fileName.click();
          URL.revokeObjectURL(fileURL);

      } else {
        this.alertService.message = 'No Data present for selected duration';
        this.alertService.showError();
      }
    });
  }

  /**
   * Function to Reset all form fields to its initial state
   *
   * @param {*} event
   * @memberof RealtimeDataComponent
   */
  public reset = (event: any) => {
    event.preventDefault();
    this.formDirective.resetForm();
    this.formRealtimeData.reset();
    this.startDateCtr = new FormControl(moment());
    this.endDateCtr = new FormControl(moment());
    if (localStorage.getItem('isMultipleSites') === 'false') {
      this.formRealtimeData.get('siteCtr').setValidators(null);
      this.formRealtimeData.get('siteCtr').updateValueAndValidity();
    } else {
      this.meterData = null;
    }
  }

}
